var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "p-3" }, [
    _c("h3", [_vm._v("Detail Pasien Tidak Aktif")]),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col" }, [
        _c("h4", { staticClass: "mb-3" }, [_vm._v("Data Pasien")]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col" }, [
            _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card-header text-white bg-primary" }, [
                _vm._v("Data Pasien"),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card-body" },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _vm._l(_vm.updated_pasiens, function (pasien, idx) {
                    return [
                      _vm.input_labels[idx]
                        ? _c("div", { key: idx, staticClass: "row mb-3" }, [
                            _c(
                              "label",
                              {
                                staticClass: "col-sm-4 col-form-label text-end",
                                attrs: { for: idx },
                              },
                              [_vm._v(_vm._s(_vm.input_labels[idx]))]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "col" }, [
                              _c("input", {
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  name: `${idx}-original`,
                                  id: `${idx}1`,
                                  disabled: "",
                                },
                                domProps: { value: _vm.detail_pasien[idx] },
                              }),
                            ]),
                          ])
                        : _vm._e(),
                    ]
                  }),
                ],
                2
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col" }, [
            _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card-header text-white bg-primary" }, [
                _vm._v("Data Registrasi"),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card-body" },
                [
                  _vm._m(1),
                  _vm._v(" "),
                  _vm._l(_vm.data_registrasi, function (register, idx) {
                    return _c("div", { key: idx, staticClass: "row mb-3" }, [
                      _c(
                        "label",
                        {
                          staticClass: "col-sm-4 col-form-label text-end",
                          attrs: { for: idx },
                        },
                        [_vm._v(_vm._s(register.Regno))]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-4" }, [
                        _c("input", {
                          staticClass: "form-control",
                          attrs: { type: "text", disabled: "" },
                          domProps: { value: register.Regdate },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-4" }, [
                        _c("input", {
                          staticClass: "form-control",
                          attrs: { type: "text", disabled: "" },
                          domProps: { value: register.poli.NMPoli },
                        }),
                      ]),
                    ])
                  }),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card mt-3" }, [
              _c("div", { staticClass: "card-header text-white bg-primary" }, [
                _vm._v(
                  "\n                            Scan Dokumen\n                        "
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card-body" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "btn btn-sm btn-success",
                      attrs: { to: `/daftar-dokumen-pasien/${_vm.Medrec}` },
                    },
                    [_vm._v("Daftar Dokumen Pasien")]
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row mb-3 fw-bold" }, [
      _c("div", { staticClass: "col-sm-4 alert alert-primary text-end" }, [
        _vm._v("Field"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col alert alert-primary text-center" }, [
        _vm._v("Data Pasien"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row mb-3 fw-bold" }, [
      _c("div", { staticClass: "col-sm-4 alert alert-primary text-end" }, [
        _vm._v("Nomor Registrasi"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm-4 alert alert-primary text-center" }, [
        _vm._v("Tanggal Registrasi"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm-4 alert alert-primary text-center" }, [
        _vm._v("Poli"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }